import React from 'react';
const Pipe90Curve2Icon = ({ width = 64, height = 64 }) => {
  const id = React.useId().replace(/:/g, '');
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 112.5 112.5">
      <defs>
        <linearGradient id={`${id}_1`} gradientUnits="userSpaceOnUse" x1="266.2324" y1="37.9233" x2="321.6895" y2="37.9233" gradientTransform="matrix(1 0 0 1 -208.7109 27.2813)">
          <stop offset="0.01" stopColor="#646464" />
          <stop offset="0.18" stopColor="#949494" />
          <stop offset="0.5" stopColor="#DFDFDF" />
          <stop offset="1" stopColor="#656565" />
        </linearGradient>
        <linearGradient id={`${id}_2`} gradientUnits="userSpaceOnUse" x1="256.0947" y1="-26.9634" x2="256.0947" y2="28.1353" gradientTransform="matrix(1 0 0 1 -208.7109 27.2813)">
          <stop offset="0.01" stopColor="#646464" />
          <stop offset="0.16" stopColor="#8F8F8F" />
          <stop offset="0.49" stopColor="#DFDFDF" />
          <stop offset="1" stopColor="#646464" />
        </linearGradient>
        <radialGradient id={`${id}_3`} cx="215.2344" cy="292.1357" r="21.5211" gradientTransform="matrix(3.0257 0.2207 -0.2208 2.9984 -535.747 -861.8795)" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#585858" />
          <stop offset="0.1" stopColor="#656565" />
          <stop offset="0.22" stopColor="#878787" />
          <stop offset="0.4" stopColor="#BDBDBD" />
          <stop offset="0.52" stopColor="#DFDFDF" />
          <stop offset="0.64" stopColor="#C2C2C2" />
          <stop offset="0.89" stopColor="#777777" />
          <stop offset="1" stopColor="#535353" />
        </radialGradient>
        <linearGradient id={`${id}_4`} gradientUnits="userSpaceOnUse" x1="266.2324" y1="62.1826" x2="321.6895" y2="62.1826" gradientTransform="matrix(1 0 0 1 -208.7109 27.2813)">
          <stop offset="0" stopColor="#656565" />
          <stop offset="0.5" stopColor="#DFDFDF" />
          <stop offset="0.82" stopColor="#949494" />
          <stop offset="0.99" stopColor="#646464" />
        </linearGradient>
        <linearGradient id={`${id}_5`} gradientUnits="userSpaceOnUse" x1="232.834" y1="28.186" x2="232.834" y2="-26.9082" gradientTransform="matrix(1 0 0 1 -208.7109 27.2813)">
          <stop offset="0" stopColor="#646464" />
          <stop offset="0.51" stopColor="#DFDFDF" />
          <stop offset="0.84" stopColor="#8F8F8F" />
          <stop offset="0.99" stopColor="#646464" />
        </linearGradient>
      </defs>
      <rect x="57.521" y="62.465" fill={`url(#${id}_1)`} width="55.457" height="5.479" />
      <rect x="45.427" y="0.318" fill={`url(#${id}_2)`} width="3.914" height="55.099" />
      <path fill={`url(#${id}_3)`} d="M47.537,0.318c31.881,0,65.391,21.782,65.391,64.923l-55.424,0.164c-1.161-7.592-4.318-9.422-9.79-9.912C47.069,41.03,47.537,0.318,47.537,0.318z" />
      <rect x="57.521" y="66.159" fill={`url(#${id}_4)`} width="55.457" height="46.609" />
      <rect x="0.283" y="0.373" fill={`url(#${id}_5)`} width="47.681" height="55.094" />
    </svg>
  );
};
export default Pipe90Curve2Icon;
